import React, { useState } from "react";
import api from "../services/api";

interface AnniversaireTableAssignmentProps {
  anniversaireId: string;
  tables: string[];
  assignments: Record<string, string>;
  protocoles: any[];
  onUpdate: () => void;
}

const AnniversaireTableAssignment: React.FC<AnniversaireTableAssignmentProps> = ({
  anniversaireId,
  tables,
  assignments,
  protocoles,
  onUpdate
}) => {
  const [assigning, setAssigning] = useState(false);

  const handleAssign = async (tableName: string, protocoleId: string) => {
    setAssigning(true);
    try {
      await api.post(`/anniversaires/${anniversaireId}/tables/assign`, {
        tableName,
        protocoleId: protocoleId || ""
      });
      onUpdate();
    } catch (error) {
      console.error("Erreur assignation:", error);
      alert("Erreur lors de l'assignation");
    } finally {
      setAssigning(false);
    }
  };

  if (tables.length === 0) {
    return (
      <div className="empty-tables">
        <p>Aucune table trouvée pour cet anniversaire.</p>
        <p className="info-text">
          Les tables sont automatiquement créées lorsque vous ajoutez des invités avec un nom de table.
        </p>
      </div>
    );
  }

  return (
    <div className="table-assignment-container">
      <h4>Assignation des tables aux protocoles</h4>
      
      <div className="assignment-table-wrapper">
        <table className="assignment-table">
          <thead>
            <tr>
              <th>Table</th>
              <th>Protocole assigné</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tables.map(table => {
              const assignedProtocoleId = assignments[table];
              const assignedProtocole = protocoles.find(p => p._id === assignedProtocoleId);
              
              return (
                <tr key={table}>
                  <td className="table-name">{table}</td>
                  <td>
                    {assignedProtocole ? (
                      <div className="assigned-info">
                        <span className="assigned-name">{assignedProtocole.name}</span>
                        <span className="assigned-phone">{assignedProtocole.phone}</span>
                      </div>
                    ) : (
                      <span className="unassigned">Non assigné</span>
                    )}
                  </td>
                  <td>
                    <select
                      value={assignedProtocoleId || ""}
                      onChange={(e) => handleAssign(table, e.target.value)}
                      disabled={assigning}
                      className="protocole-select"
                    >
                      <option value="">-- Aucun --</option>
                      {protocoles.map(p => (
                        <option key={p._id} value={p._id}>
                          {p.name} ({p.phone})
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      
      {protocoles.length === 0 && (
        <div className="warning-message">
          ⚠️ Aucun protocole trouvé. Veuillez d'abord créer des utilisateurs avec le rôle "Protocole".
        </div>
      )}
    </div>
  );
};

export default AnniversaireTableAssignment;